import { principalServiceRequest } from './base-request';
import { CustomerSuppplierPagesData } from './customer-portal-insights-endpoints.types';

export const getCustomerSupplierPages = async (
  principalId: string,
): Promise<CustomerSuppplierPagesData> => {
  return (
    await principalServiceRequest<CustomerSuppplierPagesData>(
      'get',
      `principals/${principalId}/customer-supplier-pages`,
    )
  ).data;
};
